import gsap from 'gsap'
import { TweenMax, Power2 } from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger"
import * as SmoothScroll from 'smooth-scroll'

gsap.registerPlugin(ScrollTrigger);

export default function index(){
  gsap.fromTo('#firstview .firstview__logo img',
    {},
    {
      opacity: 0,
      scale: 1.2,
      scrollTrigger: {
        trigger: '#app',
        start: "top top",
        end: "top top-=100%",
        scrub: 1,
        once: false,
        //markers: true,
        invalidateOnRefresh: true,
      }
    }
  )

  gsap.fromTo('#firstview .firstview__title',
    {},
    {
      y: 100,
      opacity: 0,
      scrollTrigger: {
        trigger: '#app',
        start: "top top",
        end: "top top-=100%",
        scrub: 1,
        once: false,
        //markers: true,
        invalidateOnRefresh: true,
      }
    }
  )

}